import { UnlayerOptions } from 'react-email-editor';
import { getStatsigGateValue } from 'util/statsig';

export const validate = (
  jsonString: string,
  htmlString: string,
  requiredMergeTags: UnlayerOptions['mergeTags'] = {},
  requiredSpecialLinks: UnlayerOptions['specialLinks'] = {},
) => ({
  ...validateTags(jsonString, requiredMergeTags, requiredSpecialLinks),
  imageErrors: validateImages(htmlString),
});

export const validateTags = (
  jsonString: string,
  requiredMergeTags: UnlayerOptions['mergeTags'] = {},
  requiredSpecialLinks: UnlayerOptions['specialLinks'] = {},
) => {
  const mergeTagErrors = Object.values(requiredMergeTags).filter(
    tag => !jsonString.includes(tag.value),
  );
  const specialLinkErrors = Object.values(requiredSpecialLinks).filter(
    tag => !jsonString.includes(tag.href),
  );

  return { mergeTagErrors, specialLinkErrors };
};

export const validateImages = (htmlString: string) =>
  htmlString.includes('data:image/');

export const replaceBadImages = (html?: string) =>
  getStatsigGateValue('350645-dashboard-fix')
    ? html?.replace(/(?:%20| )(https:\/\/email-images)/g, '$1')
    : html;
